<template>
  <div class="home">
    <Header/>
    <div class="content-box">

      <div class="main">
      
        <div class="left">
          <div class="left_div">
            <div class="left_menu">
                <div class="menu_item_first">区域选择</div>
                <div class="menu_item_div" @click="select=0" style="margin-bottom: 1px">全部</div>
                <div class="menu_item_div" @click="select=1" style="margin-bottom: 1px">宝安</div>
                <div class="menu_item_div" @click="select=2" style="margin-bottom: 2px">福田区</div>
                <div class="menu_item_div" @click="select=3" style="margin-bottom: 1px">龙岗区</div>
                <div class="menu_item_div" @click="select=4" style="margin-bottom: 1px">龙华区</div>
                <div class="menu_item_div" @click="select=5" style="margin-bottom: 1px">罗湖区</div>
                <div class="menu_item_div" @click="select=6" style="margin-bottom: 1px">南山区</div>
            </div>
          </div>
          <div class="left_div" style="margin-top:20px;">
            <div class="left_menu" style="padding-top:20px;">
               <img  style="" src="../assets/image/campus/右侧信息@2x.png"/>
            </div>
          </div>

        </div>

        <div class="right">



          <img class="campus_img" v-if="select==0||select==2" src="../assets/image/campus/益田分校@2x.png"/>
          <img class="campus_img" v-if="select==0||select==2" src="../assets/image/campus/百花分校@2x.png"/>
          <img class="campus_img" v-if="select==0||select==2" src="../assets/image/campus/长安分校@2x.png"/>
          <img class="campus_img" v-if="select==0||select==2" src="../assets/image/campus/彩田分校@2x.png"/>
          <img class="campus_img" v-if="select==0||select==2" src="../assets/image/campus/景田宏浩分校@2x.png"/>
          <img class="campus_img" v-if="select==0||select==2" src="../assets/image/campus/景田万科分校@2x.png"/>
          <img class="campus_img" v-if="select==0||select==6" src="../assets/image/campus/文心.png"/>
          <img class="campus_img" v-if="select==0||select==5" src="../assets/image/campus/翠竹.png"/>
          <img class="campus_img" v-if="select==0||select==3" src="../assets/image/campus/吉祥.png"/>
          <img class="campus_img" v-if="select==0||select==4" src="../assets/image/campus/金銮.png"/>
          <img class="campus_img" v-if="select==0||select==1" src="../assets/image/campus/宝中.png"/>
          <img class="campus_img" v-if="select==0||select==4" src="../assets/image/campus/绿景.png"/>
        </div>

      </div>



   
      <div class="home-footer">
        <Footer/>
      </div>
  </div>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
  data() {
    return {
      queryInfo:{
        currentNav: 7
      },
      select:0,
    }
  },
  components: {
    Header,
    Footer
  },
  computed: {

  },
   mounted() {
    
 },
  methods:{
      goNav(num){
         this.queryInfo.currentNav = num
      }
  }
}
</script>


<style lang="less" scoped>

  .tel {
    margin-top: 30px;;
    border-top:1px dashed #bbbbbb;
    border-left:1px dashed #bbbbbb;
    border-right:1px dashed #bbbbbb;
    border-bottom:1px solid #cddef5;
  }

  .campus_img {
    width: 400px;
  }

  .content-box {
    background-color: #f4f4f4;
  }
  .main {
    width: 60%;
    padding-top: 50px;
    margin: 0 auto;
    display: flex;
    // justify-content: flex-start;
    align-items: flex-start;
  }
  .left_menu {
    margin: 0 auto;
    width: 80%;
    img {
      width:234px;
    }
  }

  .menu_item_div {
    width: 250px;
    height: 60px;
    background-color: #1361cf;
    color: white;
    font-size: 16px;
    line-height: 60px;
    text-align: center;
  }
  .menu_item_first {
    width: 250px;
    height: 60px;
    background-color: #ffffff;
    color: #676767;
    font-size: 16px;
    line-height: 60px;
    text-align: center;
  }
  .left_div {
    width: 310px;
    background-color: #ffffff;
    padding-bottom: 30px;
    border-radius: 10px;
  }
  .left {
    margin-top: 15px;
    width: 310px;
    cursor:pointer;
  }
  .right {
    width: 900px;
    margin-left: 30px;
    display: flex;
    flex-wrap: wrap;
    cursor:pointer;
  }
  
  .home-footer {
    width: 100%;
    height: 455px;
    background: linear-gradient(0deg, #001731, #0D1241, #073371, #4281D9);
    display: flex;
    align-items: center;
    justify-items: center;
  }
</style>
